export const EXPIRATION_DATE = 'expirationDate';
export const PLATFORM_ID = 'id';
export const ADDITIONAL_PARAMS = 'additionalParameters';
export const VISIBLE_PARAMS = 'visibleParameters';
export const AD_GROUP_ID = 'adGroupId';
export const CAMPAIGN_ID = 'campaignId';
export const CONDITIONAL_REWARD_IDS = 'conditionalRewardIds';

export const HYBRID_LINK_PARAMETERS = 'hybridLinkParameters';
export const IOS_CPP = 'iosCpp';
export const ANDROID_CPP = 'androidCpp';
